import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as appZH from './zh_CN/basic.json';
import * as appTW from './zh_TW/basic.json';
import * as appEN from './en_US/basic.json';

Vue.use(VueI18n);
const i18Messages = {
  en_US: appEN.default,
  zh_CN: appZH.default,
  zh_TW: appTW.default,
};

const i18n = new VueI18n({
  locale: localStorage.getItem('language') ?? 'zh_CN',
  messages: i18Messages,
});

console.log('i18n:', i18n);

export default i18n;
